import React from 'react'
import { Box, Flex, Text, Icon, IconButton, Image, Stack } from '@chakra-ui/core'
import { X } from 'react-feather'
import { VscBell, VscHistory, VscWarning } from 'react-icons/vsc'
import Card from '../Card'
import { Enum_Notification_Type } from '../../generated/graphql'

export type NotificationCardProps = {
  title?: string
  message?: string
  createdAt?: string
  isRead?: boolean
  onClick?: () => void
  onClose?: () => void
  rightSlot?: React.ReactNode
  type?: Enum_Notification_Type
  thumbnailUrl?: string
}

const NotificationCard: React.FC<NotificationCardProps> = ({
  title,
  message,
  createdAt,
  isRead,
  onClick,
  onClose,
  rightSlot,
  type,
  thumbnailUrl
}) => {
  return (
    <Card
      p={4}
      borderBottom="1px solid"
      borderColor={isRead ? 'gray.50' : 'green.50'}
      bg={isRead ? 'white' : 'green.50'}
      onClick={onClick}
      role="button"
    >
      <Flex>
        <Flex p={2} minW="36px">
          <Icon
            as={
              type === Enum_Notification_Type.ReminderAlert
                ? VscHistory
                : type === Enum_Notification_Type.EarlyWarning
                ? VscWarning
                : VscBell
            }
            color={isRead ? 'gray.400' : 'green.600'}
            fontSize="28px"
          />
        </Flex>
        <Box flex="1">
          <Flex align="center" justify="space-between" mb={1}>
            <Stack direction="row" align="center">
              <Text
                fontSize="sm"
                fontWeight="600"
                color={isRead ? 'gray.800' : 'green.700'}
                isTruncated
              >
                {title || 'Notification'}{' '}
              </Text>
              <Text fontSize="xs" color="gray.500" whiteSpace="nowrap">
                {type === Enum_Notification_Type.EarlyWarning
                  ? '(Early Warning)'
                  : type === Enum_Notification_Type.General
                  ? '(General)'
                  : type === Enum_Notification_Type.ReminderAlert
                  ? '(Reminder)'
                  : ''}
              </Text>
            </Stack>
            {createdAt ? (
              <Text fontSize="xx-small" color="gray.500" ml={2}>
                {createdAt}
              </Text>
            ) : null}
          </Flex>
          <Flex justify="space-between" w="100%">
            {message ? (
              <Text fontSize="xs" color="gray.700" mr={4}>
                {message}
              </Text>
            ) : null}
            {thumbnailUrl ? (
              <Image src={thumbnailUrl} mt={2} borderRadius="md" w={24} objectFit="cover" />
            ) : null}
          </Flex>
        </Box>
        <Flex align="start" ml={2}>
          {rightSlot}
          {onClose ? (
            <IconButton
              aria-label="Close"
              icon={X}
              size="xs"
              variant="ghost"
              ml={2}
              onClick={(e: any) => {
                e.stopPropagation()
                onClose?.()
              }}
            />
          ) : null}
        </Flex>
      </Flex>
    </Card>
  )
}

export default NotificationCard
